<template>
  <div class="card imageMessageCard">
    <div v-show="imageDataUrl === ''">
      <i class="pi pi-image"></i> Imagem não disponível
    </div>
    <a v-show="imageDataUrl !== ''" :href="imageURLData" target="_blank" :data-testid="'image-message-link-' + messageId">
      <img :src="imageData" :id="'image_' + messageId" class="card-img-top" alt="Image">
    </a>
    <div class="card-body">
      <h5 class="card-title">{{ imageCaption }}</h5>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { log } from '../utils/DebugLogger';

interface ImageClassElement {
  LoadImage: (url: string, messageId: string) => Promise<void>;
  GetImageBlob: (messageId: string) => Promise<Blob>;
}

const props = defineProps<{
  messageId?: string;
  imageDataUrl?: string;
  imageClassElement?: ImageClassElement;
  imageCaption?: string;
}>();

const imageData = ref<string | undefined>(undefined);
const imageURLData = ref<string>('');

onMounted(async () => {
  if (!props.imageDataUrl || !props.imageClassElement || !props.messageId) return;

  try {
    await props.imageClassElement.LoadImage(props.imageDataUrl, props.messageId);
    const imageBlob = await props.imageClassElement.GetImageBlob(props.messageId);
    imageData.value = URL.createObjectURL(imageBlob);
    imageURLData.value = URL.createObjectURL(imageBlob);
  } catch (error) {
    log('ImageMessage', 'mounted', 'Error loading image:', error);
  }
});

onBeforeUnmount(() => {
  if (imageData.value) {
    URL.revokeObjectURL(imageData.value);
  }
  if (imageURLData.value) {
    URL.revokeObjectURL(imageURLData.value);
  }
});
</script>

<style scoped>
.imageMessageCard {
  max-width: 100%;
}

.card-img-top {
  max-width: 100%;
  height: auto;
}
</style>
